import React, { useEffect } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";

const getInitials = (fullName) => {
  return fullName
    .split(" ")
    .map((name) => name.charAt(0))
    .join("");
};

const PatientTablePDF = ({ data }) => {
  useEffect(() => {
    const doc = new jsPDF("landscape");

    const title = "ALBRIGHT GARDENS HOMES PPE ISOLATION CADDY AUDITS";

    const columns = [
      "Room",
      "Patient",
      "Audit Date",
      "PPE Donning/Doffing Signage present",
      "Yellow Isolation caddy stocked",
      "Precaution signage present",
      "Auditor sign",
    ];

    const tableData = data.map((row) => [
      row.Room,
      getInitials(row.Patient),
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ]);

    const titleX = doc.internal.pageSize.width / 2;
    const titleY = 10;

    doc.setFontSize(16);
    doc.text(title, titleX, titleY, { align: "center" });

    const tableY = titleY + 20;

    doc.autoTable({
      head: [columns],
      body: tableData,
      startY: tableY,
      styles: {
        lineColor: [0, 0, 0], // Color of the lines
        lineWidth: 0.5, // Width of the lines
      },
    });

    const noteText =
      "Note: Not completing these audits will result in a compliance order from the ministry";
    doc.setFontSize(10);
    doc.text(noteText, 10, doc.autoTable.previous.finalY + 10);

    doc.save("patient_table.pdf");
  }, [data]);

  return <></>;
};

export default PatientTablePDF;
